import { ApiRequest } from '../baseService'

const BaseRoute = 'app/smokeball-app'

const GetMatterDetail = (id, tenantId, companyPMSId = null) => {
  return ApiRequest.get(
    `${BaseRoute}/matters/${id}?tenantId=${tenantId ?? ''}&companyPMSId=${
      companyPMSId ?? ''
    }`
  )
}

const GetListMatters = (url, caseNo?) => {
  return ApiRequest.post(`${BaseRoute}/matters`, {
    method: 'Get',
    url: url,
    caseNo: caseNo,
  })
}

const GetListParticipant = (method, url, caseNo?) => {
  return ApiRequest.post(`${BaseRoute}/contacts`, {
    method: method,
    url: url,
    caseNo: caseNo,
  })
}

const GetMatterAccount = (matterId, companyPMSId = null) => {
  return ApiRequest.post(
    `${BaseRoute}/mattersAccount/${matterId}?companyPMSId=${companyPMSId ?? ''}`
  )
}

const API = {
  GetMatterDetail,
  GetListMatters,
  GetListParticipant,
  GetMatterAccount,
}
export default API
